export default "__VITE_ASSET__CP12ztrk__"